/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PreviousInputs */

const en_previous = /** @type {(inputs: PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

const fr_previous = /** @type {(inputs: PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Précédent`)
};

const de_previous = /** @type {(inputs: PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige`)
};

const it_previous = /** @type {(inputs: PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precedente`)
};

const ru_previous = /** @type {(inputs: PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предыдущий`)
};

const es_previous = /** @type {(inputs: PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

const zh_cn2_previous = /** @type {(inputs: PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以前的`)
};

const ja_previous = /** @type {(inputs: PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前の`)
};

const hi_previous = /** @type {(inputs: PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहले का`)
};

const pt_pt2_previous = /** @type {(inputs: PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

/**
* | output |
* | --- |
* | "Previous" |
*
* @param {PreviousInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const previous = /** @type {((inputs?: PreviousInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PreviousInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_previous(inputs)
	if (locale === "de") return de_previous(inputs)
	if (locale === "it") return it_previous(inputs)
	if (locale === "ru") return ru_previous(inputs)
	if (locale === "es") return es_previous(inputs)
	if (locale === "zh-CN") return zh_cn2_previous(inputs)
	if (locale === "ja") return ja_previous(inputs)
	if (locale === "hi") return hi_previous(inputs)
	if (locale === "pt-PT") return pt_pt2_previous(inputs)
	return en_previous(inputs)
});